export enum Decision {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  ACCEPT_AI = 'ACCEPT_AI',
  ACCEPT_HUMAN = 'ACCEPT_HUMAN',
  ACCEPT_BOTH = 'ACCEPT_BOTH',
  ACCEPT_NEITHER = 'ACCEPT_NEITHER',
}

export interface Review {
  object_uuid: string;
  object_icid: string;
  object_type?: string;
  object_view?: string;
  object_view_id?: number;
  related_object_uuid?: string;
  decision:
    | Decision.ACCEPTED
    | Decision.REJECTED
    | Decision.ACCEPT_AI
    | Decision.ACCEPT_HUMAN
    | Decision.ACCEPT_BOTH
    | Decision.ACCEPT_NEITHER;
  comment: string;
  technician_id?: string;
  technician_email?: string;
  annotation_link: string;
  history?: History[];
}

export interface ReviewIn {
  id: string;
  object_uuid: string;
  object_type?: string;
  object_view?: string;
  decision:
    | Decision.ACCEPTED
    | Decision.REJECTED
    | Decision.ACCEPT_AI
    | Decision.ACCEPT_HUMAN
    | Decision.ACCEPT_BOTH
    | Decision.ACCEPT_NEITHER;
  comment: string;
  technician_id?: string;
  technician_email?: string;
  annotation_link: string;
  timestamp: string;
  history: History[];
}

export interface History {
  object_uuid: string;
  decision:
    | Decision.ACCEPTED
    | Decision.REJECTED
    | Decision.ACCEPT_AI
    | Decision.ACCEPT_HUMAN
    | Decision.ACCEPT_BOTH
    | Decision.ACCEPT_NEITHER;
  comment: string;
  technician_email: string;
  timestamp: string;
}

export interface DashboardData {
  reviews: {
    totalReviews: number;
    acceptedReviews: number;
    rejectedReviews: number;
    pendingReviews: number;
  };
  reviewsByUser: {
    name: string;
    accepted: number;
    rejected: number;
  }[];
  reviewsByView:
    | {
        name: string | null;
        accepted: number;
        rejected: number;
      }[]
    | null;
}

export interface AnnotationSet {
  uuid: string;
  icid: string;
  name: string | null;
  createdAt: string;
  userEmail: string;
  numberOfFinishedDicomLabelingJobs: number;
  numberOfFinishedStudyLabelingJobs: number;
  totalNumberOfDicomLabelingJobs: number;
  totalNumberOfStudyLabelingJobs: number;
}

export type FrameReviewDecision = 'DISMISSED' | 'MISSING' | 'SWAP' | 'REDO';

export interface ReviewFrame {
  uuid: string | null;
  queueKey: string;
  comment: string | null;
  decision: string | null;
  dicom: string;
  dicomId: number;
  dicomIcid: string;
  frameIndex: number;
  reviewerComment: string | null;
  status: 'IN_REVIEW' | 'FIXED' | 'DISMISSED';
  studyIcid: string;
  userEmail: string | null;
  features: string[];
}

export interface ReviewFrameUpdate {
  annotationSet?: string;
  comment?: string;
  dicomId?: number;
  dicomIcid?: string;
  frameIndex: number;
  decision?: FrameReviewDecision | '3D';
  status?: 'IN_REVIEW' | 'DISMISSED';
  segmentationUpdatedAtAfter?: string;
  segmentationUpdatedAtBefore?: string;
}

export interface ReviewFramesBySegmentationUpdatedAtParams {
  updatedAtAfter?: string;
  updatedAtBefore?: string;
}
